<template>
  <CalloutBanner
    v-if="calloutBanner"
    v-bind="calloutBanner"
  />
</template>

<script lang="ts" setup>
import CalloutBanner from './CalloutBanner.vue';
import type { PortableTextCalloutBanner } from '~/sanity/types';

defineProps<PortableTextCalloutBanner>();
</script>

<style lang="scss" scoped></style>
